import stbAPIGateway from '../../../../services/stbAPIGateway';

export const getCsvExternalIdpSaml = async ({ rootGetters }, { clientSid }) => {
  const axios = rootGetters['app/stbAxios'];

  const stbApi = stbAPIGateway(axios, process.env.API_URL);

  const result = await stbApi.getHubCsvExternalIdpSaml(clientSid);
  return result;
};
